<mf-page title="Órdenes de cobro">
  <mf-row>
    <mf-collect-order-grid />
  </mf-row>
</mf-page>
